  function addPageLoadedClass() {
    document.body.classList.add('page-loaded');
    document.dispatchEvent(new CustomEvent('initSlickSlider'));
    // Remove all event listeners after the first interaction
    window.removeEventListener('scroll', onFirstInteraction);
    window.removeEventListener('keydown', onFirstInteraction);
    window.removeEventListener('mousemove', onFirstInteraction);
    window.removeEventListener('touchstart', onFirstInteraction);
    window.removeEventListener('click', onFirstInteraction);
  }

  function onFirstInteraction() {
    addPageLoadedClass();
  }

  // Listen for the first interaction of any kind
  window.addEventListener('scroll', onFirstInteraction, { once: true });
  window.addEventListener('keydown', onFirstInteraction, { once: true });
  window.addEventListener('mousemove', onFirstInteraction, { once: true });
  window.addEventListener('touchstart', onFirstInteraction, { once: true });
  window.addEventListener('click', onFirstInteraction, { once: true });

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;
    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT',
    'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
  });

  window.addEventListener('mousedown', () => { mouseClick = true; });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');
    if (mouseClick) return;
    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');
  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);
  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;
  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;
  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) return;
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () { return fn.apply(scope, arguments); };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};
  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);
  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },
  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },
  countryHandler: function () {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);
    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }
      this.provinceContainer.style.display = '';
    }
  },
  clearOptions: function (selector) {
    while (selector.firstChild) selector.removeChild(selector.firstChild);
  },
  setOptions: function (selector, values) {
    for (var i = 0; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => { this.mainDetailsToggle.classList.add('menu-opening'); });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;
    const handleAnimation = (time) => {
      if (animationStart === undefined) animationStart = time;
      const elapsedTime = time - animationStart;
      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };
    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');
    setTimeout(() => { this.mainDetailsToggle.classList.add('menu-opening'); });
    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() { super(); }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => { console.error(e); });
      }
    };
    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}
customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();
    const button = this.querySelector('button');
    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play();
      }
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => { deferredElement.setAttribute('style', formerStyle); }, 0);
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1],
        },
      }));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({ left: position });
  }
}
customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });
      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => { this.announcementBarArrowButtonWasClicked = true; }, { once: true });
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);
    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({ left: position });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');
    if (!this.sliderControlButtons.length) return;
    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;
    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach((button) => { button.removeAttribute('tabindex'); });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach((button) => { button.setAttribute('tabindex', '-1'); });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;
    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;
    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;
    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];
    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';
    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;
    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';
    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);
    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({ left: slideScrollPosition });
  }
}
customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);
      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;
    console.log('ready');
    var dataProduct = document.querySelector('product-info');
    if (dataProduct && !dataProduct.classList.contains('variant-selected')) {
      dataProduct.classList.add('variant-selected');
    }
    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}
customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() { super(); }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');
        if (recommendations?.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }
        if (html.querySelector('.grid__item')) this.classList.add('product-recommendations--loaded');
      })
      .catch((e) => { console.error(e); });
  }
}
customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();
    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) this.icon?.replaceWith(event.detail.avatar.cloneNode());
  }
}
customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });
    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) this.sendRequest(this.queue);
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};
    queue.forEach((queueItem) => { items[parseInt(queueItem.id)] = queueItem.quantity; });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = "cart-performance";

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    performance.mark(`${metricName}:start`, { startTime: event.timeStamp });
    performance.mark(`${metricName}:end`);
    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    performance.mark(`${metricName}:end`);
    performance.measure(metricName, startMarker.name, `${metricName}:end`);
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    performance.mark(`${metricName}:start`);
    callback();
    performance.mark(`${metricName}:end`);
    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }
}

// ─── Sibling Selects ──────────────────────────────────────────────────────────
(function () {
  var select = document.getElementById('headboard-siblings-select');
  if (!select) return;
  select.addEventListener('change', function (e) {
    var targetUrl = e.target.value;
    if (targetUrl && typeof targetUrl === 'string') window.location.assign(targetUrl);
  });
})();

(function () {
  var select = document.getElementById('size-siblings-select');
  if (!select) return;
  select.addEventListener('change', function (e) {
    var targetUrl = e.target.value;
    if (targetUrl && typeof targetUrl === 'string') window.location.assign(targetUrl);
  });
})();

// ─── Leg Height ───────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  const select_leg_height = document.getElementById('leg-height-select');
  const targets_leg_height = document.querySelectorAll('.leg-property-height');
  if (!select_leg_height || targets_leg_height.length === 0) return;

  function updateLegHeightProperty() {
    const value = select_leg_height.value;
    targets_leg_height.forEach(el => {
      if (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA') {
        el.value = value;
      } else {
        el.textContent = value;
      }
    });
  }

  updateLegHeightProperty();
  select_leg_height.addEventListener('change', updateLegHeightProperty);
});

// ─── Underbed Toggle ──────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  const toggle = document.querySelector('.underbed-toggle');
  const content = document.querySelector('.accordion__content');
  if (toggle && content) {
    toggle.addEventListener('click', function () {
      content.style.display = content.style.display === 'none' ? 'block' : 'none';
    });
  }
});

// ─── UBS Select ───────────────────────────────────────────────────────────────
function selectUBS(index, liElement) {
  document.querySelectorAll('.ubs li').forEach(li => li.classList.remove('selected'));
  liElement.classList.add('selected');
  console.log('Selected variant index:', index);
  const variantId = liElement.querySelector('a').dataset.variantId;
  console.log('Variant ID:', variantId);
}

// ─── Accordion ────────────────────────────────────────────────────────────────
class Accordion {
  constructor(el) {
    this.el = el;
    this.summary = el.querySelector('.summary');
    this.content = el.querySelector('.content');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.summary.addEventListener('click', (e) => this.onClick(e));
  }

  onClick(e) {
    e.preventDefault();
    this.el.style.overflow = 'hidden';
    if (this.isClosing || !this.el.open) {
      this.open();
    } else if (this.isExpanding || this.el.open) {
      this.shrink();
    }
  }

  shrink() {
    this.isClosing = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight}px`;
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 400, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(false);
    this.animation.oncancel = () => (this.isClosing = false);
  }

  open() {
    this.el.style.height = `${this.el.offsetHeight}px`;
    this.el.open = true;
    requestAnimationFrame(() => this.expand());
  }

  expand() {
    this.isExpanding = true;
    const startHeight = `${this.el.offsetHeight}px`;
    const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;
    if (this.animation) this.animation.cancel();
    this.animation = this.el.animate({ height: [startHeight, endHeight] }, { duration: 400, easing: 'ease-out' });
    this.animation.onfinish = () => this.onAnimationFinish(true);
    this.animation.oncancel = () => (this.isExpanding = false);
  }

  onAnimationFinish(open) {
    this.el.open = open;
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.el.style.height = this.el.style.overflow = '';
  }
}

const accordionEls = document.querySelectorAll('.details');
accordionEls.forEach((el) => (el._accordion = new Accordion(el)));

accordionEls.forEach((detail) => {
  detail.addEventListener('click', function () {
    accordionEls.forEach((other) => {
      if (other !== detail && other.open) {
        other._accordion.shrink();
        other.style.overflow = 'hidden';
      }
    });
  });
});

// ─── Menu Hover ───────────────────────────────────────────────────────────────
document.querySelectorAll('.header__inline-menu .list-menu li').forEach(function (li) {
  li.addEventListener('mouseenter', function () {
    const details = li.querySelector('details');
    if (details) details.open = true;
  });
  li.addEventListener('mouseleave', function () {
    const details = li.querySelector('details');
    if (details) details.open = false;
  });
});

// ─── Money Format ─────────────────────────────────────────────────────────────
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == 'string') cents = cents.replace('.', '');
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) return 0;
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount': value = formatWithDelimiters(cents, 2); break;
    case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
  }
  return formatString.replace(placeholderRegex, value);
};

// ─── Modal Custom Open/Close ──────────────────────────────────────────────────
document.addEventListener('click', function (e) {
  const opener = e.target.closest('.product__modal-opener');
  if (opener) {
    const parent = opener.closest('product-info');
    if (parent) parent.classList.add('active');
  }
});

document.addEventListener('click', function (e) {
  const closer = e.target.closest('.modal-close-custom');
  if (closer) {
    const parent = closer.closest('product-info');
    if (parent) parent.classList.remove('active');
  }
});

// ─── Lazy Load Images ─────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('img.image-load').forEach(function (img) {
    const dataSrc = img.getAttribute('data-src');
    const dataSrcset = img.getAttribute('data-srcset');
    if (dataSrc && !img.getAttribute('src')) img.setAttribute('src', dataSrc);
    if (dataSrcset && !img.getAttribute('srcset')) img.setAttribute('srcset', dataSrcset);
  });
});

// ─── Variant Cookie Manager (Cross-Sibling Sync) ─────────────────────────────
(function () {
  const COOKIE_NAME = 'selected_variants_global';
  const LEG_COOKIE = 'selected_leg_global';

  // ── Loader Helper ──────────────────────────────────────────────────────────
  function removeLoader() {
    const configurator = document.querySelector('.product-configurator');

    if (configurator) {
      configurator.classList.remove('variant-loading');
    }
  }

  // ── Cookie Helpers ─────────────────────────────────────────────────────────
  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));

    try {
      return match ? JSON.parse(decodeURIComponent(match[1])) : {};
    } catch (e) {
      return {};
    }
  }

  function setCookie(name, value, days) {
    days = days || 30;

    const expires = new Date(Date.now() + days * 864e5).toUTCString();

    document.cookie =
      name +
      '=' +
      encodeURIComponent(JSON.stringify(value)) +
      '; expires=' +
      expires +
      '; path=/';
  }

  // ── Helpers ────────────────────────────────────────────────────────────────
  function isVariantInURL() {
    return new URLSearchParams(window.location.search).has('variant');
  }

  function normalizeOptionName(name) {
    return name
      .trim()
      .toLowerCase()
      .replace(/-\d+\s*$/, '')
      .trim();
  }

  function normalizeOptionValue(value) {
    return value.trim().toLowerCase();
  }

  // ── Save Selection ─────────────────────────────────────────────────────────
  function saveVariantToCookie() {
    const all = getCookie(COOKIE_NAME);

    document.querySelectorAll('.product-configurator variant-selects input[type="radio"]:checked')
      .forEach(function (input) {
        all[normalizeOptionName(input.name)] = normalizeOptionValue(input.value);
      });

    document.querySelectorAll('.product-configurator variant-selects select')
      .forEach(function (select) {
        all[normalizeOptionName(select.name)] = normalizeOptionValue(select.value);
      });

    setCookie(COOKIE_NAME, all);
  }

  // ── Bind Listeners ─────────────────────────────────────────────────────────
  function bindVariantChangeListeners() {
    if (window.variantCookieListenerAdded) return;

    window.variantCookieListenerAdded = true;

    document.addEventListener('change', function (event) {
      var target = event.target;

      if (
        target.matches('.product-configurator variant-selects input[type="radio"]') ||
        target.matches('.product-configurator variant-selects select')
      ) {
        saveVariantToCookie();
      }
    });
  }

  // ── Restore Radio ──────────────────────────────────────────────────────────
  function restoreRadioGroup(inputs, savedValue, triggerClick) {
    inputs.forEach(function (input) {
      input.checked = false;
    });

    for (var i = 0; i < inputs.length; i++) {
      var input = inputs[i];

      if (normalizeOptionValue(input.value) === savedValue) {

        if (triggerClick) {
          input.click();

          // wait for Shopify variant update
          // setTimeout(function () {
          //   removeLoader();
          // }, 1500);
          
          const getCookies = (name) => {
            const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            return match ? decodeURIComponent(match[2]) : '';
          };

          const selectedVariants = getCookies('selected_variants_global');

          if (!selectedVariants) {
            const configurator = document.querySelector('.product-configurator');

            if (configurator && configurator.classList.contains('variant-loading')) {
              configurator.classList.remove('variant-loading');
            }
          }
          console.log('ready');
        } else {
          input.checked = true;
         console.log('ready');
        }

        return true;
      }
    }

    return false;
  }

  function get_cookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  // ── Restore Variants ───────────────────────────────────────────────────────
  function restoreVariantFromCookie() { console.log('restoreVariantFromCookie');
    var saved = getCookie(COOKIE_NAME);
    var saved_leg = get_cookie("selected_leg_global");
    
    // No saved variants
    if (!Object.keys(saved).length) {
      removeLoader();
      return;
    }

    var leg_element = document.querySelector('.product-configurator .legheightDropdown .legheight .legheight-main[value="'+saved_leg+'"]');
    console.log(leg_element, 'leg_element', saved_leg);
    if(leg_element){ 
      leg_element.click();
    }

    var elements = Array.from(
      document.querySelectorAll(
         '.product-configurator variant-selects input[type="radio"], .product-configurator variant-selects select'
      )
    );
   
    if (!elements.length) {
      removeLoader();
      return;
    }

    var groups = {};
    var orderedKeys = [];

    elements.forEach(function (el) {
      var key = normalizeOptionName(el.name);

      if (!groups[key]) {
        groups[key] = [];
        orderedKeys.push(key);
      }

      groups[key].push(el);
    });

    var keysToRestore = orderedKeys.filter(function (key) {
      
      return saved[key] !== undefined;
    });

    if (!keysToRestore.length) {
      removeLoader();
      return;
    }

    keysToRestore.forEach(function (key, index) {
      var isLast = index === keysToRestore.length - 1;
      var savedValue = saved[key];
      var group = groups[key];

      if (group[0].type === 'radio') {
        restoreRadioGroup(group, savedValue, isLast);
        return;
      }

      var select = group[0];

      var option = Array.from(select.options).find(function (opt) {
        return normalizeOptionValue(opt.value) === savedValue;
      });
      console.log('option', option);
      // if (!option) return;
      if(option){

        select.value = option.value;

        if (isLast) {
          select.dispatchEvent(
            new Event('change', {
              bubbles: true
            })
          );
          setTimeout(function () {
            removeLoader();
          }, 1500);
        }
      }
      else{
        setTimeout(function () {
            removeLoader();
          }, 1500);
      }
    });
  }

  // ── Init ───────────────────────────────────────────────────────────────────
  bindVariantChangeListeners();

  setTimeout(function () {

    // If product URL already has a variant,
    // don't restore anything, just remove loader
    if (isVariantInURL()) {
      removeLoader();
      return;
    }

    // No variant in URL, check cookie and restore
    restoreVariantFromCookie();

  }, 100);

})();


function bed_set_cookie () {
  const COOKIE_NAME = 'selected_variants_global';
  const COOKIE_LEG_NAME = 'selected_leg_global';

  function saveCardVariantCookie(data) {
    const expires = new Date(Date.now() + 30 * 864e5).toUTCString();

    document.cookie =
      COOKIE_NAME +
      '=' +
      encodeURIComponent(JSON.stringify(data)) +
      '; expires=' +
      expires +
      '; path=/';
  }

  function saveCardLegCookie(data) {
    const expires = new Date(Date.now() + 30 * 864e5).toUTCString();

    document.cookie =
      COOKIE_LEG_NAME +
      '=' +
      encodeURIComponent(data) +
      '; expires=' +
      expires +
      '; path=/';
  }

  document.querySelectorAll('.card-grid-section .card-link').forEach(function (link) {
    link.addEventListener('click', function (event) {
      event.preventDefault();

      var href = this.href;
      console.log(href, 'href');
      var options = this.getAttribute('data-options');
      var values = this.getAttribute('data-value');
      var legHeight = this.getAttribute('data-legheight');

      if (options && values) {
        var cookieData = {};
        var optionArray = options.split(',');
        var valueArray = values.split(',');

        for (var i = 0; i < optionArray.length; i++) {
          cookieData[optionArray[i].trim().toLowerCase()] =
            (valueArray[i] || '').trim().toLowerCase();
        }

        console.log('Saving variant cookie:', cookieData);
        saveCardVariantCookie(cookieData);
      }

      if (legHeight) {
        console.log('Saving leg cookie:', legHeight);
        saveCardLegCookie(legHeight);
      }

      setTimeout(function () {
        window.location.href = href;
      }, 50);
    });
  });
}



// leg height coockie
(function () {
  const COOKIE_LEG_NAME = 'selected_leg_global';

  function getLegCookie() {
    const name = COOKIE_LEG_NAME + '=';
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
      let cookie = cookies[i].trim();

      if (cookie.indexOf(name) === 0) {
        return decodeURIComponent(cookie.substring(name.length));
      }
    }

    return '';
  }

  function saveLegCookie(value) {
    const expires = new Date(Date.now() + 30 * 864e5).toUTCString();

    document.cookie =
      COOKIE_LEG_NAME +
      '=' +
      encodeURIComponent(value) +
      '; expires=' +
      expires +
      '; path=/';
  }

  document.querySelectorAll('.product-configurator').forEach(function (configurator) {
    const radios = configurator.querySelectorAll('.legheight-main');

    if (!radios.length) return;

    // Restore from cookie
    const savedValue = getLegCookie();

    const previewImgss = document.querySelector('.product-option.image-label img');

    if (savedValue) {
      radios.forEach(function (radio) {
        if (radio.value === savedValue) {
          radio.checked = true;

          const label = radio.closest('label');
          const img = label ? label.querySelector('img') : null;

          if (img && previewImgss) {
            previewImgss.src = img.src;
            previewImgss.alt = img.alt || '';
          }

          radio.dispatchEvent(new Event('change', { bubbles: true }));
          
          if (document.querySelector('product-info')) {
          if (!document.querySelector('product-info').classList.contains('variant-selected')) {
            document.querySelector('product-info').classList.add('variant-selected');
          }
        }
        }
      });
    }

    // Save on change
    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (this.checked) {
          saveLegCookie(this.value);
        }
      });
    });
  });
})();


function runFilters(){

    var fetchRecords = true;
    const result = [];
    let spanActive = false;

    function hideFilter(){
      // Get active cards
      const activeCards = document.querySelectorAll(
        ".card-grid-section.active-card"
      );

      activeCards.forEach((card) => {
        // Get all items
        const multiColumns = card.querySelectorAll(".multicolumn-list__item");

        multiColumns.forEach((multiColumn) => {
          const sectionInfo = multiColumn.getAttribute("data-info");

          if (sectionInfo) {
            const sectionArray = sectionInfo
              .split(",")
              .map((item) => item.trim().toLowerCase());

            result.push(...sectionArray);
          }
        });
      });

      // Make unique
      const uniqueResult = [...new Set(result)];

      console.log(uniqueResult, 'uniqueResult');

      // Match spans
      const spans = document.querySelectorAll(
        ".collection-richtext .rich-text__buttons span[data-main]"
      );

      let firstActiveSpan = document.querySelector(
        ".collection-richtext .rich-text__buttons.tab-active span.active[data-main]"
      );

      spans.forEach((span) => {
        const dataMain = span
          .getAttribute("data-main")
          ?.trim()
          .toLowerCase();

        // Parent div
        const parentDiv = span.parentElement;
        parentDiv.classList.remove('no-active');
        parentDiv.classList.remove('tab-active');
        if (parentDiv) {
          if (uniqueResult.includes(dataMain)) {
            parentDiv.style.display = "";
            parentDiv.classList.add('tab-active');

            // Save first visible span
            if (!firstActiveSpan) {
              firstActiveSpan = span;
            }
          } else {
            parentDiv.style.display = "none";
            parentDiv.classList.add('no-active');
          }
        }
      });

      // Click first active span

      if(!firstActiveSpan){
        firstActiveSpan = document.querySelector(
          ".collection-richtext .rich-text__buttons.tab-active span[data-main]"
        );
      }

      if (firstActiveSpan) {
        fetchRecords = false;
        firstActiveSpan.click();
      }
    }

    document.addEventListener('click', function (e) { 


      if (!e.target.classList.contains('btn-filter')) return;


      console.log('click', spanActive);



      var btn = e.target;
      var filterValue = btn.getAttribute('data-main');
      var rawLabel = btn.textContent.trim();
      var items = document.querySelectorAll('.filters-list');

      // ─────────────────────────────────────────────
      // Helpers
      // ─────────────────────────────────────────────

      function normalize(s) {
        return String(s)
          .toLowerCase()
          .replace(/[\u2018\u2019\u201A\u201B\u2032]/g, "'")
          .replace(/[\u201C\u201D\u201E\u201F\u2033]/g, '"')
          .replace(/[\u2013\u2014\u2212]/g, '-')
          .replace(/-/g, ' ')
          .replace(/\s+/g, ' ')
          .trim();
      }

      function getCollectionHandle() {
        var path = window.location.pathname.toLowerCase();

        var m = path.match(/\/collections\/([^\/\?#]+)/);

        if (!m) return '';

        return normalize(
          m[1].replace(/-beds$/, '')
        );
      }

      function extractSize(title) {

        var n = normalize(title);

        var idx = n.lastIndexOf(' in ');

        if (idx === -1) return n;

        var tail = n.slice(idx + 4);

        tail = tail
          .split(',')[0]
          .split('(')[0]
          .trim();

        return normalize(tail);
      }

      function findSibling(data, size) {

        if (!data || !data.siblings || !data.siblings.length) {
          return null;
        }

        var target = normalize(size);

        // Exact
        for (var i = 0; i < data.siblings.length; i++) {

          if (extractSize(data.siblings[i].title) === target) {
            return data.siblings[i];
          }
        }

        // Partial
        for (var i = 0; i < data.siblings.length; i++) {

          var sz = extractSize(data.siblings[i].title);

          var re = new RegExp(
            '(^|\\s)' +
            target.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') +
            '($|\\s)'
          );

          if (re.test(sz)) {
            return data.siblings[i];
          }
        }

        return null;
      }

      function parseData(card) {

        var s = card.querySelector(
          'script.js-product-bad-variants'
        );

        if (!s) return null;

        try {
          return JSON.parse(s.textContent);
        } catch (e) {
          return null;
        }
      }

      function moneyToNumber(str) {

        if (str === null || str === undefined) {
          return null;
        }

        var cleaned = String(str).replace(/[^0-9.\-]/g, '');

        if (cleaned === '' || cleaned === '-' || cleaned === '.') {
          return null;
        }

        var n = parseFloat(cleaned);

        return isNaN(n) ? null : n;
      }

      // ─────────────────────────────────────────────
      // Snapshot / Restore
      // ─────────────────────────────────────────────

      function snapshot(card) {

        if (card.dataset.sibSnap === '1') return;

        var priceEl = card.querySelector('.save_price');
        var crossWrap = card.querySelector('.cross_price');
        var crossEl = card.querySelector('.cross_price s');
        var saveWrap = card.querySelector('.save_per');
        var saveSpan = card.querySelector('.save_per-title span');
        var linkEl = card.querySelector('.card-link');

        if (priceEl) card.dataset.snapPrice = priceEl.innerHTML;
        if (crossEl) card.dataset.snapCross = crossEl.innerHTML;

        if (crossWrap) {
          card.dataset.snapCrossDisplay =
            crossWrap.style.display || '';
        }

        if (saveSpan) {
          card.dataset.snapSave = saveSpan.innerHTML;
        }

        if (saveWrap) {
          card.dataset.snapSaveDisplay =
            saveWrap.style.display || '';
        }

        if (linkEl) {
          card.dataset.snapHref =
            linkEl.getAttribute('href') || '';
        }

        card.dataset.sibSnap = '1';
      }

      function restore(card) {

        if (card.dataset.sibSnap !== '1') return;

        var priceEl = card.querySelector('.save_price');
        var crossWrap = card.querySelector('.cross_price');
        var crossEl = card.querySelector('.cross_price s');
        var saveWrap = card.querySelector('.save_per');
        var saveSpan = card.querySelector('.save_per-title span');
        var linkEl = card.querySelector('.card-link');

        if (
          priceEl &&
          card.dataset.snapPrice !== undefined
        ) {
          priceEl.innerHTML = card.dataset.snapPrice;
        }

        if (
          crossEl &&
          card.dataset.snapCross !== undefined
        ) {
          crossEl.innerHTML = card.dataset.snapCross;
        }

        if (
          crossWrap &&
          card.dataset.snapCrossDisplay !== undefined
        ) {
          crossWrap.style.display =
            card.dataset.snapCrossDisplay;
        }

        if (
          saveSpan &&
          card.dataset.snapSave !== undefined
        ) {
          saveSpan.innerHTML = card.dataset.snapSave;
        }

        if (
          saveWrap &&
          card.dataset.snapSaveDisplay !== undefined
        ) {
          saveWrap.style.display =
            card.dataset.snapSaveDisplay;
        }

        if (
          linkEl &&
          card.dataset.snapHref !== undefined
        ) {
          linkEl.setAttribute(
            'href',
            card.dataset.snapHref
          );
        }
      }

      // ─────────────────────────────────────────────
      // Apply sibling
      // ─────────────────────────────────────────────

      function applySibling(card, sibling) {

        snapshot(card);

        var priceEl = card.querySelector('.save_price');
        var crossWrap = card.querySelector('.cross_price');
        var crossEl = card.querySelector('.cross_price s');
        var saveWrap = card.querySelector('.save_per');
        var saveSpan = card.querySelector('.save_per-title span');
        var linkEl = card.querySelector('.card-link');

        var priceNum = moneyToNumber(sibling.price);
        var compareNum = moneyToNumber(sibling.comparePrice);

        var hasDiscount =
          priceNum !== null &&
          compareNum !== null &&
          compareNum > priceNum;

        // Price
        if (priceEl && sibling.price) {

          if (hasDiscount) {

            priceEl.innerHTML =
              '<span class="save-label">Save</span> ' +
              sibling.price;

          } else {

            priceEl.innerHTML = sibling.price;
          }
        }

        // Compare
        if (crossEl) {

          crossEl.innerHTML =
            hasDiscount ? sibling.comparePrice : '';
        }

        if (crossWrap) {

          crossWrap.style.display =
            hasDiscount ? '' : 'none';
        }

        // Save %
        if (saveWrap && saveSpan) {

          if (hasDiscount) {

            var savePct = Math.round(
              ((compareNum - priceNum) / compareNum) * 100
            );
            console.log(savePct,"savePct");
            saveSpan.innerHTML = savePct + '%';

            saveWrap.style.display = '';

          } else {

            saveWrap.style.display = 'none';
          }
        }

        // Link
        if (linkEl && sibling.url) {

          linkEl.setAttribute('href', sibling.url);
        }
      }

      // ─────────────────────────────────────────────
      // Update Sections
      // ─────────────────────────────────────────────

      function updateSections(filterValue) {

        var collectionHandle = getCollectionHandle();

        var activeFilter = normalize(filterValue);

        document.querySelectorAll('[data-section-info]')
          .forEach(function (sec) {

          var sinfo =
            sec.getAttribute('data-section-info') || '';

          var values = sinfo.split(',')
            .map(function (s) {
              return normalize(s);
            });

          var matchesFilter =
            values.indexOf(activeFilter) !== -1;
        
          var matchesCollection =
            values.indexOf(collectionHandle) !== -1;

          var wrap =
            sec.closest('.shopify-section') || sec;

            wrap.style.display =
            (matchesFilter && matchesCollection)
              ? ''
              : 'none';
              wrap.classList.toggle(
              'active-card',
              (matchesFilter && matchesCollection)
            );


        });
        if(spanActive) return; 
        hideFilter();
      }

      // ─────────────────────────────────────────────
      // Active button
      // ─────────────────────────────────────────────

      document.querySelectorAll('.btn-filter')
        .forEach(function (b) {

        b.classList.remove('active');
      });

      btn.classList.add('active');

      // ─────────────────────────────────────────────
      // Product cards
      // ─────────────────────────────────────────────

    items.forEach(function (item) {
    
      const link = item.querySelector('.multicolumn-card a.card-link');

      if (link) {
        link.href = link.href.replace(/-in-.*/, `-in-${filterValue}`);
        if(fetchRecords == true){
            let handle = link.getAttribute("href").split('/').pop();
            let data_options = encodeURIComponent(link.getAttribute('data-options'));
            let data_values = encodeURIComponent(link.getAttribute('data-value'));
            let url = `https://api.glazedigital.com/warren-evans-api/get-variant.php?handle=${handle}&data-options=${data_options}&data-value=${data_values}`;

            fetch(`${url}`)
              .then(res => res.json())
              .then(data => {

                let price = data.price?.amount ?? 0;
                let compare = data.compareAtPrice?.amount ?? 0;
                let parent_ele = link.closest('.multicolumn-card');

                let price_ele = parent_ele.querySelector('.cross_price-wrap .save_price');
                if (price && price_ele != null) {
                  price_ele.innerHTML = Shopify.formatMoney(data.price.amount * 100);
                }
                let compare_ele = parent_ele.querySelector('.cross_price-wrap .cross_price s');
                if (compare && compare_ele != null) {
                  compare_ele.innerHTML = Shopify.formatMoney(data.compareAtPrice.amount * 100);
                }

                let newSave = calculateSavingsPercent(price, compare);
                let currentSave = parent_ele.querySelector('.save_per span');
                if (newSave && currentSave != null && compare > 0) {
                  if (currentSave) currentSave.innerHTML = `${newSave}%`;
                }
              });

        }
      }
    });
      if(fetchRecords == false){
      fetchRecords = true;
      }
      // ─────────────────────────────────────────────
      // Sections
      // ─────────────────────────────────────────────

      updateSections(filterValue);

      // Save active filter
      localStorage.setItem(
        'activeBedFilter',
        filterValue
      );
    });

    // ─────────────────────────────────────────────
    // On load / reload
    // ─────────────────────────────────────────────


    function calculateSavingsPercent(price, compareAtPrice) {
      const currentPrice = parseFloat(price);
      const originalPrice = parseFloat(compareAtPrice);

      if (!originalPrice || originalPrice <= currentPrice) {
        return 0; // no discount, or invalid/missing compareAtPrice
      }

      const savings = ((originalPrice - currentPrice) / originalPrice) * 100;

      return Math.round(savings); // rounds to nearest whole number
    }

    function getHandle() {

      var path =
        window.location.pathname.toLowerCase();

      var m =
        path.match(/\/collections\/([^\/\?#]+)/);

      if (!m) return '';

      return m[1]
        .replace(/-beds$/, '')
        .trim();
    }

    function init() {

      if (!document.querySelector('.btn-filter')) {
        document.dispatchEvent(new CustomEvent('runFiltersComplete')); 
        return;
      }

      var savedFilter =
        localStorage.getItem('activeBedFilter');

      var key =
        savedFilter || getHandle();

      var btn = Array.prototype.slice
        .call(document.querySelectorAll('.btn-filter'))
        .filter(function (b) {

          return (
            (b.getAttribute('data-main') || '')
              .toLowerCase() === key.toLowerCase()
          );

        })[0];

      if (btn && false) {

        btn.classList.remove('active');

        setTimeout(function () {
          fetchRecords = false;
          btn.click();
        }, 50);

      } else {

        var activeBtn =
          document.querySelector('.btn-filter.active');

        if (activeBtn) {
          var link = window.location.href.split('/').pop();
          if(link === 'beds-sale' || link === 'off-sale-beds' ){
            spanActive = true;
          }else{
            spanActive = false;
          }
          
          activeBtn.classList.remove('active');

          setTimeout(function () {
          fetchRecords = false;
            activeBtn.click();
            document.dispatchEvent(new CustomEvent('runFiltersComplete')); 
            
          }, 1000);
        }
      }
    }


      var url = window.location.href;
      // Get last URL part
      var handle = url.split('/').pop();
      // Remove "-beds"
      handle = handle.replace(/-beds$/, '');
      let spanEle = document.querySelector(`.collection-richtext .rich-text__buttons span[data-main="${handle}"]`);
      if(spanEle){
        spanActive = true;
        spanEle.click();
        console.log(spanEle, 'spanEle');
      }
      console.log(spanActive, 'spanActive', handle);
      if(!spanActive){
        setTimeout(function(){
          init();
        }, 100);
      }
      
}


document.addEventListener('DOMContentLoaded', async () => {
  const wrappers = document.querySelectorAll('.get-collection-wrapper');

  if (!wrappers.length) return;

  await Promise.all(
    Array.from(wrappers).map(async wrapper => {
      const pageUrl = wrapper.dataset.collectionUrl;
      const html = await fetch(pageUrl).then(res => res.text());

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const main = doc.querySelector('main');

      if (main) wrapper.innerHTML = main.innerHTML;
      if (window.location.pathname.includes('/collections/platform-beds')) {
          wrapper.querySelectorAll('.card_grid_weekly-li').forEach((item) => {
            if (!item.classList.contains('platform-beds')) {
              item.remove();
            }
          });
        }
    })
  );

  bed_set_cookie();

  document.addEventListener('runFiltersComplete', () => {
    const activeFilterBtn = document.querySelector('.btn-filter.active');
    if (activeFilterBtn) {
      activeFilterBtn.click();
    }
  }, { once: true });

  runFilters();
});



// save underbed value in coockie 
function saveUnderbedStorageCookie() {
  const selected = [];

  document.querySelectorAll('.underbed_storage_input:checked').forEach(input => {
    selected.push(input.dataset.variantid);
  });

  if (selected.length === 0) return;

  document.cookie = `underbed_storage=${encodeURIComponent(JSON.stringify(selected))}; path=/; max-age=${60 * 60 * 24 * 30}`;
}
function restoreUnderbedStorageCookie() {
  const cookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('underbed_storage='));

  if (!cookie) return;

  const value = decodeURIComponent(cookie.split('=')[1]);

  if (!value) return;

  const selected = JSON.parse(value);

  selected.forEach(variantId => {
    const input = document.querySelector(
      `.underbed_storage_input[data-variantid="${variantId}"]`
    );
    
    if (input) {
      input.checked = true;
      
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
}


document.addEventListener('change', function (e) {
  if (e.target.classList.contains('underbed_storage_input')) {
    saveUnderbedStorageCookie();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  document.cookie = 'underbed_storage=; path=/; max-age=0';
});
document.addEventListener("retoreUnderBed", function (event) {
  console.log('READYYY');
  restoreUnderbedStorageCookie();
});

document.addEventListener('DOMContentLoaded', function () {

  function updatePostalError() {
    var tab3 = document.querySelector('[rel="cs-tab3"]');
    var errors = document.querySelectorAll('#postal-code-error');
    var error = errors[errors.length - 1];

    if (!tab3 || !error) return;

    if (tab3.classList.contains('active')) {
      setTimeout(function () {
        error.textContent = 'Please select date and time. Note the delivery address on the next page will be pre populated with our N11 2UD workshop collection address above.';
      }, 50);
    }
  }

  // updatePostalError();

  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[rel="cs-tab2"], [rel="cs-tab3"]');

    if (!tab) return;

    if (tab.getAttribute('rel') === 'cs-tab3') {
      setTimeout(function () {
        updatePostalError();
      }, 50);
    }
  });

});